// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDuplicateClaimDto } from './IDuplicateClaimDto';
import {
    IDuplicateClaimDtoFromJSON,
    IDuplicateClaimDtoFromJSONTyped,
    IDuplicateClaimDtoToJSON,
    IDuplicateClaimDtoToJSONTyped,
} from './IDuplicateClaimDto';

/**
 * 
 * @export
 * @interface IOcrDuplicateDocumentWarningDto
 */
export interface IOcrDuplicateDocumentWarningDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrDuplicateDocumentWarningDto
     */
    warning?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IOcrDuplicateDocumentWarningDto
     */
    fields?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IOcrDuplicateDocumentWarningDto
     */
    type?: IOcrDuplicateDocumentWarningDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IOcrDuplicateDocumentWarningDto
     */
    duplicate_receipt_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IOcrDuplicateDocumentWarningDto
     */
    duplicate_document_id?: number;
    /**
     * 
     * @type {IDuplicateClaimDto}
     * @memberof IOcrDuplicateDocumentWarningDto
     */
    duplicate_claim?: IDuplicateClaimDto;
}

/**
* @export
* @enum {string}
*/
export enum IOcrDuplicateDocumentWarningDtoTypeEnum {
    MISSING = 'MISSING',
    WRONG_SERVICE = 'WRONG_SERVICE',
    OUT_OF_COVERAGE_DATE = 'OUT_OF_COVERAGE_DATE',
    RETAIL_OUT_OF_COVERAGE_DATE = 'RETAIL_OUT_OF_COVERAGE_DATE',
    DUPLICATE_RECEIPT = 'DUPLICATE_RECEIPT'
}


/**
 * Check if a given object implements the IOcrDuplicateDocumentWarningDto interface.
 */
export function instanceOfIOcrDuplicateDocumentWarningDto(value: object): value is IOcrDuplicateDocumentWarningDto {
    return true;
}

export function IOcrDuplicateDocumentWarningDtoFromJSON(json: any): IOcrDuplicateDocumentWarningDto {
    return IOcrDuplicateDocumentWarningDtoFromJSONTyped(json, false);
}

export function IOcrDuplicateDocumentWarningDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrDuplicateDocumentWarningDto {
    if (json == null) {
        return json;
    }
    return {
        
        'warning': json['warning'] == null ? undefined : json['warning'],
        'fields': json['fields'] == null ? undefined : json['fields'],
        'type': json['type'] == null ? undefined : json['type'],
        'duplicate_receipt_id': json['duplicate_receipt_id'] == null ? undefined : json['duplicate_receipt_id'],
        'duplicate_document_id': json['duplicate_document_id'] == null ? undefined : json['duplicate_document_id'],
        'duplicate_claim': json['duplicate_claim'] == null ? undefined : IDuplicateClaimDtoFromJSON(json['duplicate_claim']),
    };
}

export function IOcrDuplicateDocumentWarningDtoToJSON(json: any): IOcrDuplicateDocumentWarningDto {
    return IOcrDuplicateDocumentWarningDtoToJSONTyped(json, false);
}

export function IOcrDuplicateDocumentWarningDtoToJSONTyped(value?: IOcrDuplicateDocumentWarningDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warning': value['warning'],
        'fields': value['fields'],
        'type': value['type'],
        'duplicate_receipt_id': value['duplicate_receipt_id'],
        'duplicate_document_id': value['duplicate_document_id'],
        'duplicate_claim': IDuplicateClaimDtoToJSON(value['duplicate_claim']),
    };
}

